import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-[1400px] mx-auto px-6 text-center py-20">
      <h1 className="text-6xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
      <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">Page not found</p>
      <button
        onClick={() => navigate('/dashboard')}
        className="px-6 py-3 bg-black text-white dark:bg-white dark:text-black rounded-lg font-medium hover:bg-dark-bg transition-colors inline-block"
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default NotFound;